import axios from 'axios';
import { formatError } from 'utils/axios';
import { DataDogLogger } from 'utils/dataDog';
import { GenericImage1 } from './assets';
import { formatNum } from './string-helpers';

const getVehicleDetailsById = async (vehicleId: string) => {
  try {
    const vehicleDetailsRequest = await axios.get(
      `${process.env.CVNA_APIK_BASE_URL}/merch/vehicledetails/api/v1/vehicledetails/lite?vehicleId=${vehicleId}`,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      },
    );

    const {
      data: { header: vehicle },
    } = vehicleDetailsRequest;

    if (!vehicle) {
      return null;
    }

    const { year, make, model, trim = '', price, mileage, evoxImages = null } = vehicle;

    const image =
      (evoxImages && evoxImages.length > 0 && evoxImages[0] && evoxImages[0].urlToImage) ||
      GenericImage1;

    return {
      description: `${trim} <br /> $${formatNum(price)} | ${formatNum(mileage)} miles`,
      image,
      title: `${year} ${make} ${model}`,
    };
  } catch (error: unknown) {
    DataDogLogger.error('Get Vehicle Details By Id - Error', {
      url: `${process.env.CVNA_APIK_BASE_URL}/merch/vehicledetails/api/v1/vehicledetails/lite?vehicleId=${vehicleId}`,
      ...formatError(error),
    });
  }
};

const getVehicleDetailsBySku = async (sku: string) => {
  try {
    // Call VDP endpoint
    const vehicleDetailsRequest = await axios.post(
      `${process.env.CVNA_APIK_BASE_URL}/mobile/search/api/v8/inventory`,
      {
        filters: {
          keywords: sku,
        },
      },
      {
        headers: {
          'Content-Type': 'application/json',
        },
      },
    );

    const {
      data: {
        data: {
          inventory: { vehicles },
        },
      },
    } = vehicleDetailsRequest;

    if (vehicles && vehicles.length > 0) {
      const vehicle = vehicles[0];
      const { year, make, model, trim = '', mileage, image = '', price } = vehicle;
      const imageUrl = image || GenericImage1;
      if (!year || !make || !model || !mileage || !price) {
        return null;
      }
      return {
        description: `${trim} <br /> $${formatNum(price)} | ${formatNum(mileage)} miles`,
        image: imageUrl,
        title: `${year} ${make} ${model}`,
      };
    }
  } catch (error: unknown) {
    DataDogLogger.error(new Error('Get Vehicle Details - Error'), {
      url: `${process.env.CVNA_APIK_BASE_URL}/mobile/search/api/v8/inventory`,
      sku,
      ...formatError(error),
    });
  }

  return null;
};

export { getVehicleDetailsById, getVehicleDetailsBySku };
